import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d28f786"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_avatar = _resolveComponent("base-avatar")!
  const _component_heading_3 = _resolveComponent("heading-3")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_separator = _resolveComponent("separator")!
  const _component_subtitle_1 = _resolveComponent("subtitle-1")!
  const _component_base_card = _resolveComponent("base-card")!

  return ($props.userInfo)
    ? (_openBlock(), _createBlock(_component_base_card, {
        key: 0,
        class: "profile-card"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_base_avatar, {
                src: $setup.profileImage,
                class: "profile-card__avatar"
              }, null, 8, ["src"]),
              _createVNode(_component_heading_3, { class: "user-name" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.userInfo.firstName) + " " + _toDisplayString($props.userInfo.familyName), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_separator),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_subtitle_1, { class: "user-description" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.userInfo.address) + " ", 1),
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString($props.userInfo.zipCode) + ", " + _toDisplayString($props.userInfo.city), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}